import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResponsiveContainer, ResponsiveContent, ResponsiveHeader, ResponsiveFooter } from '../ui/ResponsiveLayout';

const Frame260: React.FC = () => {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate('/frame-214');
  };

  const handleBack = () => {
    navigate('/frame-140');
  };

  return (
    <ResponsiveContainer background="stone">
      <ResponsiveContent>
        <ResponsiveHeader
          title="Complete Your Legal Essentials"
        />

        <div className="max-w-4xl space-y-8">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              Taking care of your legal essentials is a meaningful way to protect the people you care about most.
              By gathering and organizing these documents now, you’re helping ensure your wishes are clearly
              understood and easier to carry out—so your loved ones aren’t left guessing during an already difficult time.
            </p>
            <p className="text-stone-800 text-lg font-medium font-['Work_Sans'] leading-relaxed">
              You don’t need everything perfect or finished today. This is simply a thoughtful step toward
              clarity, peace of mind, and preparedness.
            </p>
          </div>

          {/* What You'll Do Section */}
          <div className="bg-white rounded-lg border border-neutral-200 p-6">
            <h2 className="text-xl font-semibold text-cyan-900 mb-4">What You'll Do</h2>
            <div className="space-y-4">
              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  1
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Upload Important Legal Documents
                  </h3>
                  <p className="text-stone-600">
                    Add your will, power of attorney, and healthcare directives so they’re easy to access when needed.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  2
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Choose Your Executor
                  </h3>
                  <p className="text-stone-600">
                    Select someone you trust to carry out your wishes, if you’re ready to make that decision.
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-cyan-700 text-white flex items-center justify-center font-semibold">
                  3
                </div>
                <div>
                  <h3 className="font-semibold text-stone-800 mb-1">
                    Keep Everything Organized
                  </h3>
                  <p className="text-stone-600">
                    Store everything in one secure, accessible place so it’s easy to find when it matters.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Why This Matters */}
          <div className="bg-cyan-50 border border-cyan-100 rounded-lg p-6">
            <h2 className="text-lg font-semibold text-cyan-900 mb-3">Why This Matters</h2>
            <ul className="space-y-2 text-stone-700">
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Clear legal documents help ensure your wishes are respected</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Designating an executor provides guidance and reduces uncertainty</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Organization today can prevent stress, confusion, and delays later</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-cyan-700 mt-1">✓</span>
                <span>Your loved ones will know where to find what they need, when it matters most</span>
              </li>
            </ul>
          </div>

          {/* Time Estimate */}
          <div className="text-center text-stone-600">
            <p className="text-sm">
              <span className="font-semibold">Estimated time:</span> Approximately 10–20 minutes
            </p>
          </div>
        </div>
      </ResponsiveContent>

      <ResponsiveFooter
        title="Complete Your Legal Essentials"
        subtitle="Understand what legal documents to prepare"
        progressPercent={0}
        onNext={handleNext}
        onBack={handleBack}
        nextText="Get Started"
        backText="Back to Dashboard"
      />

    </ResponsiveContainer>
  );
};

export default Frame260;